/** Session expiry rules. `refreshExp` is the refresh token's expiry, seconds since epoch. */

const EXPIRING_WINDOW_MS = 5 * 60 * 1000;

export const isSessionExpired = (refreshExp: number, now = Date.now()): boolean =>
  now > refreshExp * 1000;

/** In the last five minutes and not yet expired, so the "expiring" and "expired" prompts never overlap. */
export const isSessionExpiring = (refreshExp: number, now = Date.now()): boolean =>
  !isSessionExpired(refreshExp, now) && refreshExp * 1000 - now <= EXPIRING_WINDOW_MS;
